import { render, staticRenderFns } from "./AppTat.vue?vue&type=template&id=a5f27ece&"
import script from "./AppTat.vue?vue&type=script&lang=js&"
export * from "./AppTat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports